<template>
  <div class="blog-grid">
    <h4 class="title">{{ title }} <span class="primary">{{ primaryTitle }}</span>{{ endTitle }}</h4>
    <p v-text="subTitle" v-if="subTitle != ''" class="mt-10px"></p>
    <div class="author mb-4">
      <div class="author-thumb">
        <img class="" :src="icon" alt="tip-seguridad">
      </div>
    </div>
    <div v-if="contentPage == 1">
      <p>
        <strong>Verifica la URL en tu navegador.</strong> <br><br>
        Es de suma importancia que verifiques detalladamente que la URL del navegador
        sea exactamente <strong>https://www.redgirasol.com</strong>, o si ya has iniciado sesión,
        la URL debe ser <strong>https://app.redgirasol.com</strong> ya que, en algunos casos, los navegadores
        no muestran el URL completo, por lo que podría aparecer únicamente redgirasol.com.
        Asegúrate que aparezca el resto de la liga, al hacer clic.
        <br><br>
        <strong>¿“L” o “i”?</strong>
        <br><br>
        Asegúrate de que la última letra de la palabra “redgirasol” en la URL, <strong>sea una letra
          “L” en minúscula</strong>, ya que en ocasiones se puede reemplazar por una letra “i”
        en mayúscula (“I”), y puede verse muy parecido a la URL original. Por ejemplo:
        Aquí tenemos “redgirasoI” escrito con una “i” mayúscula y aquí “redgirasol”
        con una letra “L” minúscula. <strong>Aprende a identificar la diferencia.</strong>
        <br><br>
        <strong>Entrar en el sitio web escribiendo la URL directamente en el navegador.</strong>
        <br><br>
        Evita entrar a través de otros enlaces externos. Al entrar en
        <strong>https://www.redgirasol.com</strong>
        verifica
        en tu navegador que a un lado de la URL aparezca un candado cerrado. <strong>Si tiene la forma
          de un candado abierto, estarás en un sitio falso.</strong> No intentes iniciar sesión ni realices
        ninguna
        transacción hasta que te asegures que te encuentras en el sitio oficial de RedGirasol.
        <br><br>
        <strong>RedGirasol nunca te pedirá tu contraseña.</strong>
        <br><br>
        <strong>Y en ningún momento te solicitará los 6 dígitos de tu segundo factor de autenticación.</strong>
        Además de que no te solicitará ningún tipo de información personal o financiera a través
        de otro medio que no sea el sitio web oficial <strong>https://www.redgirasol.com</strong> o los
        <strong>medios
          de contacto oficiales</strong> de RedGirasol.
      </p>
    </div>
    <div v-if="contentPage == 2">
      <p>
        <strong>Sigue los criterios de una contraseña segura.</strong> <br><br>
        Tener una contraseña de mínimo 8 caracteres, que incluya al menos una letra
        minúscula, una letra mayúscula, un número y un caracter alfanumérico.
        Nosotros recomendamos que sean de hasta <strong>14 caracteres para mayor seguridad</strong>.
        No comentar a nadie el patrón utilizado para formar la contraseña, no anotarla
        en medios físicos y usar técnicas para memorizarla.
        <br><br>
        <strong>Procura no usar información que otros puedan saber de ti.</strong>
        <br><br>
        <strong>No incluir palabras relacionadas a cosas que cualquier persona pudiera saber de ti</strong>,
        como tu nombre y/o apellidos al derecho o al revés, fechas importantes
        como cumpleaños, aniversarios, etc., el nombre de personas muy cercanas a ti
        como tu pareja, familiares o amigos cercanos, el nombre de tu mascota,
        el nombre de tu equipo deportivo, conjunto musical, o comida favorito(s), etc.
      </p>
    </div>

    <div v-if="contentPage == 3">
      <p>
        <strong>¡No te dejes engañar!</strong> <br><br>
        Procura revisar detalladamente tus correos electrónicos, verifica que la dirección
        del remitente sea de quien dice ser, el nombre y la arroba (@) de la cuenta
        de correo de RedGirasol deben de estar escritos correctamente en cada correo
        electrónico que recibas. Puedes tomar el siguiente cuestionario creado por Google
        para que aprendas como puedes ser engañado a través de este medio
        <strong>https://phishingquiz.withgoogle.com/</strong>
        <br><br>
        <strong>Evita las descargas sospechosas.</strong>
        <br><br>
        <strong>No descargues cualquier archivo adjunto que se te sea enviado</strong>, examina la URL
        de los enlaces dentro del contenido del correo ya que te pueden redireccionar a sitios
        falsos. Te recomendamos contar con un antivirus reconocido que evite la descarga
        no autorizada de archivos que puedan poner tu información en riesgo.
        <br><br>
        <strong>No compartas tus correos.</strong>
        <br><br>
        No reenvíes correos electrónicos que recibes de RedGirasol, sobre todo
        si contienen ligas de activación, de renovación de contraseña, etc.
      </p>
    </div>

    <div v-if="contentPage == 4">
      <p>
        <strong>Protege tu cuenta y mantente alerta.</strong> <br><br>
        Ante cualquier anomalía que detectes en tu cuenta o dentro de la página <strong>no dudes
          en contactarnos a través del chat en redgirasol.com</strong>. No compartas cualquier tipo
        de información personal o confidencial en las redes sociales.
        <br><br>
        <strong>Mantén tus claves seguras.</strong>
        <br><br>
        Al activar el doble factor de autenticación, no compartir el código secreto
        para evitar el robo de cuenta y operaciones no autorizadas. Procura no introducir
        tu contraseña o tu segundo factor de autenticación en lugares públicos para evitar
        el robo de tu cuenta.
      </p>
    </div>

    <div v-if="contentPage == 5" class="mt-5">
      <ul class="list-style">
        <li><strong>1.</strong> RedGirasol te proporcionará la información necesaria dentro de nuestra plataforma
          (<strong><a @click.stop="goToPage('home')">https://www.redgirasol.com</a></strong>) para hacer el
          pago
          inicial de tu crédito.</li>
        <li><strong>2.</strong> Investiga a fondo sobre la institución financiera y no te dejes guiar porque
          aparezcan logos
          de CONDUSEF, de la CNBV o RedGirasol en redes sociales o en la página,
          en donde te ofrezcan el crédito.</li>
        <li><strong>3.</strong> Si recibes una llamada y te solicitan datos de tu cuenta o contraseña no los
          proporciones.</li>
        <li><strong>4.</strong> Revisa continuamente tu Buro de Crédito y si identificas alguna irregularidad,
          repórtala de inmediato.</li>
        <li><strong>5.</strong> No abras correos electrónicos o des clic en links desconocidos o de dudosa
          procedencia.
          <a class='' href="#correo" @click="goToMailContent">Ver más</a>
        </li>
        <li><strong>6.</strong> Si recibes un mensaje SMS que indica que tu cuenta ha sido bloqueada, comunícate a
          través
          de los medios de contacto oficiales de RedGirasol; Chat en linea y contacto@redgirasol.com</li>
        <li><strong>7.</strong> RedGirasol no cuenta con sucursales, módulos o alguna oficina física con el
          objetivo
          de recibir dinero en efectivo, recabar documentación personal para realizar algún trámite.</li>
        <li><strong>8.</strong> Si se presentan personas en tu domicilio o en espacios públicos identificándose
          como empleados
          de RedGirasol, no entregues ningún tipo de documento o información. RedGirasol no realiza
          ningún trámite de manera presencial. Los instaladores deben identificarse
          y son los responsables de recabar y entregar la documentación del proyecto.</li>
        <li><strong>9.</strong> RedGirasol solo se encarga de ofrecer el plan de financiamiento del proyecto. No
          se involucra
          en el proceso de cotización, instalación y/o interconexión con la CFE de las tecnologías financiadas.
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Content",
  props: ['value'],
  data() {
    return {
      contentPage: this.value,
      title: '',
      primaryTitle: '',
      endTitle: '',
      subTitle: '',
      icon: '',
      idTitle: ''
    }
  },
  mounted() {
    this.renderContent();
    window.vueController = this;
  },
  methods: {
    renderContent() {
      switch (this.contentPage) {
        case 1:
          this.idTitle = 'plataforma';
          this.title = 'Nuestra';
          this.primaryTitle = 'Plataforma';
          this.endTitle = '.';
          this.subTitle = '';
          this.icon = 'https://cdn.redgirasol.com/green/ICONOS/Computadora.png';
          break;
        case 2:
          this.idTitle = 'contrasena';
          this.title = 'Tu';
          this.primaryTitle = 'Contraseña';
          this.endTitle = '.';
          this.subTitle = '';
          this.icon = 'https://cdn.redgirasol.com/green/ICONOS/Contraseña.png';
          break;
        case 3:
          this.idTitle = 'correo';
          this.title = 'Tu';
          this.primaryTitle = 'correo';
          this.endTitle = ' electrónico.';
          this.subTitle = '';
          this.icon = 'https://cdn.redgirasol.com/green/ICONOS/Correo_Electrónico.png';
          break;
        case 4:
          this.idTitle = 'cuidate';
          this.title = '¡Cuídate!';
          this.primaryTitle = '';
          this.endTitle = '';
          this.subTitle = '';
          this.icon = 'https://cdn.redgirasol.com/green/ICONOS/Cuidate.png';
          break;
        case 5:
          this.idTitle = 'evita-ser-estafado';
          this.title = '¿Estás por adquirir un ';
          this.primaryTitle = 'crédito';
          this.endTitle = '?';
          this.subTitle = `Consulta a detalle las siguientes recomendaciones que deberás 
          seguir antes de comenzar con el proceso de solicitud y aceptación 
          de crédito con RedGirasol.`;
          this.icon = 'https://cdn.redgirasol.com/green/ICONOS/Estafa.png';
          break;
      }
    },
    goToMailContent() {
      this.idTitle = 'correo';
      this.contentPage = 3;
      this.renderContent();
    }
  },
  watch: {
    value: function (newV, oldV) {
      this.contentPage = newV;
      this.renderContent();
    }
  }
}
</script>

<style>
.padding-15 {
  padding-right: 15px;
  padding-left: 15px;
}

ul.listSecAdv li {
  margin-bottom: 20px;
}
</style>